export default __webpack_public_path__ + "static/image10-f5c1043c8236fffab6f970f8dce9757d.png";